module.exports = __webpack_public_path__ + "img/slider3.8a9fd5a.jpg";